import { PineappleIcon } from "@/components/PineappleIcon";
import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ eyebrow, title, copy, align = "center", dark = false }) => {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <Reveal className={`max-w-2xl ${alignCls}`}>
      {eyebrow && <p className="eyebrow" data-testid="section-eyebrow">{eyebrow}</p>}
      <h2
        className={`mt-4 font-serif text-3xl font-semibold leading-tight tracking-tight sm:text-4xl ${
          dark ? "text-ivory" : "text-charcoal"
        }`}
      >
        {title}
      </h2>
      {copy && (
        <p className={`mt-4 text-sm leading-relaxed sm:text-base ${dark ? "text-ivory/70" : "text-charcoal-soft"}`}>
          {copy}
        </p>
      )}
      {align === "center" && (
        <div className="mt-5 flex items-center justify-center gap-3" aria-hidden="true">
          <span className="h-px w-10 bg-gold/40" />
          <PineappleIcon className="h-5 w-5 text-gold" />
          <span className="h-px w-10 bg-gold/40" />
        </div>
      )}
    </Reveal>
  );
};

export const PageHero = ({ eyebrow, title, copy }) => (
  <section className="relative overflow-hidden bg-cream pb-14 pt-32 sm:pb-20 sm:pt-44">
    <div
      className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-gold/10 blur-3xl"
      aria-hidden="true"
    />
    <PineappleIcon
      className="pointer-events-none absolute -bottom-10 right-6 h-56 w-40 rotate-12 text-gold/10"
      strokeWidth={1}
    />
    <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
      <Reveal>
        <p className="eyebrow" data-testid="page-hero-eyebrow">{eyebrow}</p>
        <h1 className="mt-4 font-serif text-4xl font-semibold leading-[1.12] tracking-tight text-charcoal sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {copy && <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-charcoal-soft sm:text-base">{copy}</p>}
      </Reveal>
    </div>
  </section>
);
